import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const Page = lazy(() => import('./spaces-page'));

export const SpacesPage = () => {
  return (
    <LazyRoute>
      <Page />
    </LazyRoute>
  );
};
